import type { ProductDetailsData, ProductDetailsSticksData } from "@jti/fe-common";

import type { ProductTeaserCarouselProps } from "@/components/ProductTeaserCarousel/ProductTeaserCarousel.inputs";

import { createSafeContentWithData } from "../builder/tools/createSafeContentWithData/createSafeContentWithData";

import type { ProductsMap } from "./products";

const { Content: SticksProductContent, createDefaultDataBindings: createSticksProductDefaultDataBinding } =
  createSafeContentWithData<{
    productSku: string;
    productBadgeText: string;
    productOverwriteBadgeText: string;
    productDescription: string;
    productShortDescription: string;
    productKnowMoreUrl: string;
    productMultiPackDescription: string;
    productName: string;
    productHasBadge: boolean;
    productHasDiscountBadge: boolean;
    productHasStrikethroughPrice: boolean;
    productHideCta: boolean;
    productIsCommerceDisabled: boolean;
    productIsMultiPackEnabled: boolean;
    productHidePrice: boolean;
    productMultiPackName: string;
    productMultiPackProducts: ProductDetailsData["multiPackProducts"];
    productCustomBuyCtaLabel: string;
    productSticksMatrixData: ProductDetailsSticksData;
    productIsSubscriptionsEnabled: boolean;
    teaserProducts: ProductTeaserCarouselProps["items"];
    products: ProductsMap;
  }>();

export { createSticksProductDefaultDataBinding, SticksProductContent };
